<template>
  <div class="cortex-tool-call">
    <div class="cortex-tool-call__header" @click="toggle">
      <i class="fas fa-wrench mr-1"></i>
      <span class="cortex-tool-call__name">{{ toolCall.name }}</span>
      <b-badge variant="secondary" class="ml-2 cortex-tool-call__type">{{ toolCall.type || 'tool' }}</b-badge>
      <i :class="['ml-auto', expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down']"></i>
    </div>
    <div v-if="expanded" class="cortex-tool-call__body">
      <div v-if="toolCall.arguments" class="cortex-tool-call__section">
        <small class="text-muted d-block mb-1">{{ $t('kortex.toolInput') }}</small>
        <pre class="cortex-tool-call__code">{{ formattedArguments }}</pre>
      </div>
      <div v-if="toolCall.result" class="cortex-tool-call__section">
        <small class="text-muted d-block mb-1">{{ $t('kortex.toolOutput') }}</small>
        <pre class="cortex-tool-call__code cortex-tool-call__code--result">{{ formattedResult }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolCallCard',
  props: {
    toolCall: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      expanded: false
    }
  },
  computed: {
    formattedArguments: function () {
      try {
        return JSON.stringify(JSON.parse(this.toolCall.arguments), null, 2)
      } catch (e) {
        return this.toolCall.arguments || ''
      }
    },
    formattedResult: function () {
      if (!this.toolCall.result) return ''
      try {
        return JSON.stringify(JSON.parse(this.toolCall.result), null, 2)
      } catch (e) {
        return this.toolCall.result
      }
    }
  },
  methods: {
    toggle: function () {
      this.expanded = !this.expanded
    }
  }
}
</script>

<style scoped lang="scss">
.cortex-tool-call {
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  margin-bottom: 8px;
  font-size: 13px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
}

.cortex-tool-call__header {
  display: flex;
  align-items: center;
  padding: 9px 12px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.04);
  user-select: none;
  transition: background 0.12s;

  &:hover {
    background: rgba(255, 255, 255, 0.07);
  }
}

.cortex-tool-call__name {
  font-weight: 600;
  font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', monospace;
  color: rgba(255, 255, 255, 0.75);
}

.cortex-tool-call__type {
  color: rgba(255, 255, 255, 0.75);
}

.cortex-tool-call__type {
  font-size: 11px;
  text-transform: uppercase;
  background: rgba(108, 128, 255, 0.12) !important;
  color: rgba(148, 168, 255, 0.85) !important;
  border: none !important;
}

.cortex-tool-call__body {
  padding: 10px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.cortex-tool-call__section {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  small {
    color: rgba(255, 255, 255, 0.35) !important;
  }
}

.cortex-tool-call__code {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 7px;
  padding: 10px 12px;
  font-size: 12px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', monospace;
  line-height: 1.5;

  &--result {
    background: rgba(0, 180, 100, 0.08);
    border-color: rgba(0, 200, 100, 0.15);
  }
}
</style>
